import React from "react";
import { Link } from "react-router-dom";
import CategoryDropdown from './CategoryDropdown';

function Footer({ cart }) {
  return (
    <footer className="bg-base-200/60 p-10">
      <div className="container mx-auto grid grid-cols-1 gap-6 md:grid-cols-3">
        {/* Column 1: Branding and Newsletter */}
        <div>
          <div className="flex items-center gap-2 text-xl font-bold">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.6745 16.9224L12.6233 10.378C12.2167 9.85117 11.4185 9.8611 11.0251 10.3979L6.45728 16.631C6.26893 16.888 5.96935 17.0398 5.65069 17.0398H3.79114C2.9635 17.0398 2.49412 16.0919 2.99583 15.4336L11.0224 4.90319C11.4206 4.38084 12.2056 4.37762 12.608 4.89668L20.9829 15.6987C21.4923 16.3558 21.024 17.3114 20.1926 17.3114H18.4661C18.1562 17.3114 17.8638 17.1677 17.6745 16.9224ZM12.5866 15.5924L14.8956 18.3593C15.439 19.0105 14.976 20 14.1278 20H9.74075C8.9164 20 8.4461 19.0586 8.94116 18.3994L11.0192 15.6325C11.4065 15.1169 12.1734 15.0972 12.5866 15.5924Z"
                fill="currentColor"
              />
            </svg>
            <span>Crow Spores</span>
          </div>
          <p className="text-base-content/90 mt-4">
            Buy magic mushroom spores in USA.
          </p>
          <p>USA,info@crowspore.com</p>
          <form className="mt-6">
            <fieldset>
              <label className="label label-text" htmlFor="subscribeLetter">
                Subscribe to our newsletter
              </label>
              <div className="flex w-full flex-wrap gap-1 sm:flex-nowrap">
                <input
                  className="input input-sm flex-1"
                  id="subscribeLetter"
                  placeholder="johndoe@gmail.com"
                />
                <button className="btn btn-sm btn-primary" type="submit">
                  Subscribe
                </button>
              </div>
            </fieldset>
          </form>
        </div>

        {/* Column 2: Services and Company */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          <nav>
            <h6 className="footer-title">Company</h6>
            <Link to="/" className="block p-2 hover:underline">
              Home
            </Link>
            <Link to="/about-us" className="block p-2 link link-hover">
              About us
            </Link>
            <Link to="/contact-us" className="block p-2 link link-hover">
              Contact
            </Link>
            <Link to="/shop" className="block p-2 hover:underline">
              Shop
            </Link>
            <CategoryDropdown />
            <Link to="/cart" className="block p-2 hover:underline">
              Cart ({cart.length})
            </Link>
            <Link to="/checkout" className="block p-2 hover:underline">
              Checkout
            </Link>
            <Link to="/track_order" className="block p-2 hover:underline">
              Track Order
            </Link>
          </nav>
        </div>

        {/* Column 3: Legal */}
        <div>
          <nav>
            <h6 className="footer-title">Disclaimer:</h6>
            <p>All Psilocybe cubensis Muhsroom Spores sold on this website are for research purposes only.</p>

          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
